module.exports = __webpack_public_path__ + "static/media/check-small.be0f9e7b.svg";